import { GenericTableConfigViewEntry } from './dto';

export const DefaultVisibleConfigsTableColumnConfig: Array<keyof GenericTableConfigViewEntry | 'actions'> = [
    'id',
    'name',
    'dataSourceFileName',
    'createdTimestamp',
    'actions',
];

export const SearchableConfigsTableColumnConfig: Array<keyof GenericTableConfigViewEntry> = ['name'];
